import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  localeGuard: true,
  monolithPrefix: '/365FarmNet/dist/index.html',
  servicesPrefix: '/mod',
  userLanePropertyId: '2296m',
};
